<template>
    <div>
        <FormulateForm
            style="margin: 20px"
            @submit="sendRequest"
        >
            <FormulateInput
                v-model="lista_origen_id"
                :options="listas"
                type="select"
                placeholder="Selecciona una opción"
                label="Lista de origen"
            />
            <FormulateInput
                type="text"
                name="name"
                label="Lista de abonados activa"
                :value="user.lista.id + ' - ' + user.lista.nombre"
                disabled
            />
            <FormulateInput
                v-model="solo_activos"
                :options="{true: 'Sí', false: 'No'}"
                type="select"
                placeholder="Selecciona una opción"
                label="Solo activos"
            />

            <FormulateInput
                type="submit"
                label="Clonar lista"
            />
        </FormulateForm>
        <h3>{{respuesta}}</h3>
    </div>
</template>

<script>
    export default {
        name: "AbonadosFromLista",
        data() {
            return {
                lista_origen_id: null,
                solo_activos: true,
                respuesta: "",
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            },
            listas() {
                let l = {};
                for(let i in this.user.listas) {
                    l[this.user.listas[i].id] = this.user.listas[i].id + ' - ' + this.user.listas[i].nombre;
                }
                return l;
            }
        },
        methods: {
            async sendRequest() {
                this.respuesta = "Espera...";
                let url = this.config.API_BASE + '/listas-abonados/'+ this.user.lista.id+'/import/lista/'+ this.lista_origen_id +'?api_key='
                    + localStorage.getItem('token') ;

                let formdata = new FormData();
                formdata.append("solo_activos", this.solo_activos);

                let requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                fetch(url, requestOptions)
                    .then(response => response.text())
                    .then(result => this.respuesta = result)
                    .catch(error => this.respuesta = error);
            }
        }
    }
</script>

<style scoped>

</style>